import Dispatcher, { dispatcher } from 'lib/Dispatcher';
import EventEmitter from 'events';
import { EventEmitter as FbEmitter } from 'fbemitter';

// @ts-ignore
EventEmitter.defaultMaxListeners = Number.MAX_VALUE;

declare var __DEV__: boolean;

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class Store extends EventEmitter {
  constructor() {
    super();

    this.__changeEvent = 'change';
    this.__fbemitter = new FbEmitter();
    this.__dispatcher = dispatcher;

    this._dispatchToken = dispatcher.register(this.getDispatchHandler());
    this.state = this.getInitialState();

    if (__DEV__ && typeof window !== 'undefined') {
      // @ts-ignore
      window.stores = window.stores || {};
      // @ts-ignore
      window.stores[this.constructor.name] = this;
    }
  }

  state: { [key: string]: any };
  __dispatcher: Dispatcher<any>;
  _dispatchToken: any;
  __changeEvent: string;
  __fbemitter: FbEmitter;

  setState(state: Object) {
    this.state = state;
    this.emitChange();
  }

  resetState(): void {
    this.setState(this.getInitialState());
  }

  getDispatchHandler() {
    return this.handleDispatch.bind(this);
  }

  /* This should be overridden in subclasses */
  handleDispatch(_action: Object): void {
    return undefined;
  }

  /* This should be overridden in subclasses */
  getInitialState(): any {
    return {};
  }

  emitChange() {
    this.emit(this.__changeEvent);
    this.__fbemitter.emit(this.__changeEvent);
  }

  /**
   * @deprecated older Node-style event emitter
   * @param {Function} callback [description]
   */
  addChangeListener(callback: (...args: any[]) => void) {
    this.on(this.__changeEvent, callback);
  }

  waitFor(stores: Store[]) {
    return this.__dispatcher.waitFor(stores.map(store => store._dispatchToken));
  }

  //
  // interfaces for FluxUtils
  //

  /**
   * @public
   * @param {function} callback
   * @return {object} EmitterSubscription that can be used with
   *   SubscriptionsHandler or directly used to release the subscription.
   */
  // XXX this signature doesn't match EventEmitter parent
  // @ts-ignore
  addListener(callback: (...args: any[]) => void) {
    return this.__fbemitter.addListener(this.__changeEvent, callback);
  }

  /**
   * @public
   * @return {Dispatcher} The dispatcher that this store is registered with.
   */
  getDispatcher(): Dispatcher<any> {
    return this.__dispatcher;
  }

  /**
   * @public
   * @return {string} A string the dispatcher uses to identify each store's
   *   registered callback. This is used with the dispatcher's waitFor method
   *   to declaratively depend on other stores updating themselves first.
   */
  getDispatchToken(): any {
    return this._dispatchToken;
  }
}

export default Store;
